'use client';

import { HomeHero } from './components/home-hero';

export default function HomePage() {
  return (
    <div className="container mx-auto flex flex-col items-center px-4 py-8 md:flex-row">
      <HomeHero />
    </div>
  );
}
